import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { VMSConstants } from 'src/app/shared/constants/vms-constants';
import { SharedService } from 'src/app/shared/services';
import { ClientMaster } from '../../models';
import { ClientMasterService } from '../../services';
import { Message } from 'primeng/api';
import { ConfirmationService, ConfirmEventType, MessageService } from 'primeng/api';
import { UserServiceAdmin } from '../../../users/services';
@Component({
  selector: 'app-client-master',
  templateUrl: './client-master.component.html',
  styleUrls: ['./client-master.component.css'],
  providers: [MessageService,ConfirmationService]
})
export class ClientMasterComponent implements OnInit {
  states:any;
  countries: any;
  clientMasterForm: FormGroup;
  userEmail;
  userEmailAvail;
  clientName: any;
  clientNameAvail: any;
  constructor(private formBuilder: FormBuilder,
     public sharedService:SharedService, 
     private clientMasterService:ClientMasterService,
     private _router: Router,
     private messageService: MessageService,
     private userService: UserServiceAdmin,
     private confirmationService: ConfirmationService) { 

  }
  initialSetup() {
    this.clientMasterForm = this.formBuilder.group({
      companyName: new FormControl('', [Validators.maxLength(VMSConstants.nameMaxLength), Validators.required]),
      companyTypeId: new FormControl(4),
      companyShortName: new FormControl('', [Validators.maxLength(VMSConstants.nameMaxLength), Validators.required]),
      primaryEmail: new FormControl('', [Validators.pattern(VMSConstants.emailValidator),Validators.required]),
      addressLine1: new FormControl('', [Validators.required]),
      addressLine2: new FormControl(''),
      taxIdNumber: new FormControl(''),
      webAddress: new FormControl(''),
      city: new FormControl('', [Validators.required]),
      stateId: new FormControl(1, [Validators.required]),
      countryId: new FormControl(1, [Validators.required]),
      zipCode: new FormControl('', [Validators.required]),
      zipCodeExt: new FormControl(''),
      approvalStatusId: new FormControl(29)
    })
  }

  checkViewPermission()
   {
     var result = this.sharedService.checkPermission("Admin_View");
     if(!result)
     this._router.navigateByUrl('/login');
   }

  ngOnInit(): void {
    this.checkViewPermission();
    this.initialSetup();
    this.getStates();
    this.countries = [
      { name: 'USA', code: 'USA', id: 1 }
    ];
  }

  getStates()
  {
    this.sharedService.getStates().subscribe((data: any)=> {
      this.states = data;
    });
  }

  save({value}: {value: ClientMaster}){
    this.clientMasterService.createClient(value).subscribe(data => {
       this.messageService.add({severity:'info', summary:'Created', detail:'You have successfully added the record'});
      //this.clientMasterForm.reset();
    // this._router.navigateByUrl('/admin/client-master'); 

    //window.location.r
    setTimeout(() => {
      //this.spinner.hide();
      let currentUrl = this._router.url;
      this._router.navigateByUrl('/', {skipLocationChange: true}).then(() => {
          this._router.navigate([currentUrl]);
      });
  }, 1000)
   
    // this.confirmationService.confirm({
    //   message: 'You have successfully added the record. Do you want continue?',
    //   header: 'Client Master',
    //   icon: 'pi pi-exclamation-triangle',
    //   accept: () => {
    //     // this.submitHoursMismatchConfirm(this.selectedInvoiceList);
    //     this._router.navigateByUrl('/admin/client-master');  
    //   },
    //   reject: (type) => {
    //     this._router.navigateByUrl('/admin/client-master');  
    //   }
    //   });

    }, error => {
      console.log(error);
    })
  }
  onlyNumbers($event) {
    let regex: RegExp = new RegExp(/^[0-9]{1,}$/g);
    let specialKeys: Array<string> = ['.', 'Backspace', 'Tab', 'End', 'Home', 'ArrowRight', 'ArrowLeft'];
    if (specialKeys.indexOf($event.key) !== -1) {
      return;
    } else {
      if (regex.test($event.key)) {
        return true;
      } else {
        return false;
      }
    }
  }
  
  checkEmail() {
    this.userEmail = this.clientMasterForm.controls['primaryEmail'].value;
    if (this.userEmail != '') {
      this.userService.onVendorEmailCheck(this.userEmail).subscribe((data: any) => {
        this.userEmailAvail = data;
      });
    }
  }
  onClientNameAvailabilityCheck(){
    this.clientName = this.clientMasterForm.controls['companyName'].value;
    if (this.clientName != '') {
      this.clientName = this.clientName.trim();
      this.clientMasterService.onClientNameCheck(this.clientName).subscribe((data: any) => {
        this.clientNameAvail = data;
      });
    }
  }
}
